"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpotOrder = void 0;
const rxjs_1 = require("rxjs");
const errors_1 = require("../../../interface/errors");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const CheckBasicRequest_1 = require("../CheckBasicRequest");
const processSpotUIOrderRequest = (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { accountType, symbol, orderType, side, price, curPrice, investSide, invest, available, canBuy, baseTotal, volume, leveragedCoinQuota, leveragedCoinAccountQuota, } = params;
    // 判断参数完整
    if (!curPrice) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_CURRENT_PRICE);
    }
    if (orderType === interface_1.CustomOrderType.LIMIT && !price) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_LIMIT_PRICE);
    }
    if (!invest) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_INVEST);
    }
    if (!available) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_AVAILABLE);
    }
    const investD = new trade_utils_lib_1.SafeDecimal(invest);
    const limitPriceD = new trade_utils_lib_1.SafeDecimal(price);
    const tradePrice = orderType === interface_1.CustomOrderType.LIMIT ? price : curPrice;
    const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
    // 1. 判断参数符合 market info 参数合法 最小投资额
    if (tradePrice && Number(tradePrice)) {
        if (orderType === interface_1.CustomOrderType.LIMIT) {
            if (investSide === interface_1.InvestSymbolSide.base) {
                // 投 base
                const minBaseD = (0, CheckBasicRequest_1.minBase)(symbol, tradePrice);
                if (investD.lessThan(minBaseD)) {
                    const err = errors_1.TRADE_QTY_LOW_THAN_MIN;
                    err.data.min = minBaseD.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (investD.greaterThan((0, CheckBasicRequest_1.maxBase)(symbol, tradePrice))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_QTY_HIGH_THAN_MAX);
                }
            }
            else {
                // 投quote
                const minQuoteD = (0, CheckBasicRequest_1.minQuote)(symbol, tradePrice);
                if (investD.lessThan(minQuoteD)) {
                    const err = errors_1.TRADE_COST_LOW_THAN_MIN;
                    err.data.min = minQuoteD.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (investD.greaterThan((0, CheckBasicRequest_1.maxQuote)(symbol, tradePrice))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_COST_HIGH_THAN_MAX);
                }
            }
        }
        else {
            if (side === interface_1.CustomOrderSide.BUY) {
                const minSp = new trade_utils_lib_1.SafeDecimal((_b = (_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.spending.min) !== null && _b !== void 0 ? _b : 0);
                if (investD.lessThan(minSp)) {
                    const err = errors_1.TRADE_COST_LOW_THAN_MIN;
                    err.data.min = minSp.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (investD.greaterThan(new trade_utils_lib_1.SafeDecimal((_d = (_c = symbol.limit) === null || _c === void 0 ? void 0 : _c.spending.max) !== null && _d !== void 0 ? _d : Number.MAX_VALUE))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_QTY_HIGH_THAN_MAX);
                }
            }
            else {
                const minDump = new trade_utils_lib_1.SafeDecimal((_f = (_e = symbol.limit) === null || _e === void 0 ? void 0 : _e.dumping.min) !== null && _f !== void 0 ? _f : 0);
                if (investD.lessThan(minDump)) {
                    const err = errors_1.TRADE_QTY_LOW_THAN_MIN;
                    err.data.min = minDump.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (investD.greaterThan(new trade_utils_lib_1.SafeDecimal((_h = (_g = symbol.limit) === null || _g === void 0 ? void 0 : _g.dumping.max) !== null && _h !== void 0 ? _h : Number.MAX_VALUE))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_QTY_HIGH_THAN_MAX);
                }
            }
        }
    }
    // 判断限价单挂单价格合法
    if (orderType === interface_1.CustomOrderType.LIMIT && ((_j = symbol.limit) === null || _j === void 0 ? void 0 : _j.price)) {
        if (side === interface_1.CustomOrderSide.BUY) {
            // 禁止过高买入
            if (limitPriceD.greaterThan(new trade_utils_lib_1.SafeDecimal((_k = symbol.limit.price.max) !== null && _k !== void 0 ? _k : Number.MAX_VALUE))) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_PRICE_HIGH);
            }
        }
        else {
            // 禁止过低卖出
            if (tradePriceD.lessThan(new trade_utils_lib_1.SafeDecimal((_l = symbol.limit.price.min) !== null && _l !== void 0 ? _l : 0))) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_PRICE_LOW);
            }
        }
    }
    // 判断canBuy是否合法
    if (canBuy) {
        if (investD.greaterThan(new trade_utils_lib_1.SafeDecimal(canBuy))) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_AVAILABLE_NOT_ENOUGH);
        }
    }
    // 判断杠杆代币额度
    if (symbol.symbolType === trade_utils_lib_1.ExchangeSymbolType.leveraged_coin) {
        if (baseTotal && leveragedCoinQuota && leveragedCoinAccountQuota && volume) {
            const baseTotalD = new trade_utils_lib_1.SafeDecimal(baseTotal);
            const volumeD = new trade_utils_lib_1.SafeDecimal(volume);
            // 预期成交后所持有的该杠杆代币的总价值
            const esBaseTotalVolume = baseTotalD.mul(tradePriceD).add(volumeD);
            if (volumeD.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(leveragedCoinQuota))) {
                // 判断下单价值是否超过全网剩余额度
                const error = errors_1.TRADE_LEVERAGED_TOTAL_QUOTA;
                error.data.quota = leveragedCoinQuota;
                return (0, rxjs_1.throwError)(error);
            }
            else if (esBaseTotalVolume.greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(leveragedCoinAccountQuota))) {
                // 判断成交后总价值是否超过账号总额度限制
                const error = errors_1.TRADE_LEVERAGED_ACCOUNT_LIMIT;
                error.data.quota = leveragedCoinQuota;
                return (0, rxjs_1.throwError)(error);
            }
        }
    }
    let realAmount = investD;
    // 限价单用户投quote的时候需要把数值转换成base
    if (orderType === interface_1.CustomOrderType.LIMIT && investSide === interface_1.InvestSymbolSide.quote) {
        realAmount = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(investD.div(new trade_utils_lib_1.SafeDecimal(price)), symbol.amount);
    }
    const useSpending = orderType === interface_1.CustomOrderType.MARKET && side === interface_1.CustomOrderSide.BUY;
    const request = {
        accountType: accountType,
        symbol: symbol.symbol,
        type: orderType,
        side: side,
        price: price || undefined,
        amount: !useSpending ? realAmount.toString() : undefined,
        spending: useSpending ? realAmount.toString() : undefined,
        confirmed_sensitive: true,
    };
    return (0, rxjs_1.of)(request);
};
const createSpotOrder = (preRequest) => {
    return processSpotUIOrderRequest(preRequest).pipe((0, operators_1.mergeMap)((req) => {
        return (0, FutureAPI_1.postCustomOrder)(req);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.createSpotOrder = createSpotOrder;
